import { useCallback } from 'react';
import { prop } from 'ramda';

import { JACKPOTS_REDUCER } from 'js/store/constants';
import { useCustomSelector } from 'js/store/hooks';

export const useJackpotFilter = () => {
    const jackpotList = useCustomSelector(JACKPOTS_REDUCER, prop('jackpots'));

    return useCallback(gameConfig => {
        const jackpot = jackpotList?.[gameConfig.jackpotCode];

        return Boolean(jackpot?.amount);
    }, [jackpotList]);
};
